@if (CompanyId) {
  <div class="container-fluid d-flex flex-column h-100">
    <div class="row flex-grow-1 pb-4">
      <div class="col">
        <app-notes-grid
          [suppliedQueryData]="SuppliedGridQueryData"
          [gridName]="'ClientHistory'"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [FilterModel]="FilterModel"
          [SortState]="SortState"
          (rowClick)="action({ action: 'view', rowData: $event.data })"
        ></app-notes-grid>
      </div>
    </div>
  </div>
}
